import { COMPANY, STATS } from "@/data/content";
import { SectionLabel } from "@/components/SectionLabel";
import { AccentHeading } from "@/components/AccentHeading";
import { Reveal } from "@/components/Reveal";
import { CountUpStat } from "@/components/CountUpStat";

export const About = () => (
  <section id="about" data-testid="about" className="relative bg-[var(--bg-warm)] py-16 md:py-24 lg:py-28">
    <div className="container-pad grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <Reveal><SectionLabel>ABOUT US</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <AccentHeading as="h2" text="A Legacy of Trust &amp; *Excellence*" className="mt-4 block text-4xl leading-[1.05] md:text-5xl" />
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 leading-relaxed text-[var(--text-secondary)]">{COMPANY.about1}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-6 border-l-2 border-[var(--accent-primary)] pl-5">
            <div className="font-playfair text-xl text-[var(--accent-secondary)]">Our Vision &mdash; {COMPANY.visionTitle}</div>
            <p className="mt-2 leading-relaxed text-[var(--text-secondary)]">{COMPANY.vision}</p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 grid max-w-md grid-cols-3 gap-4">
            {STATS.map((s) => (
              <CountUpStat key={s.label} value={s.value} suffix={s.suffix} label={s.label} testId={s.testId} />
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1}>
        <div className="relative">
          <div className="overflow-hidden rounded-[28px] border border-[var(--border-subtle)] shadow-[var(--shadow-md)]">
            <img src="/images/about.jpg" alt="Premium marble lobby and construction quality by Godavari Builders" className="h-[420px] w-full object-cover md:h-[560px]" />
          </div>
          <div className="absolute -bottom-5 left-5 rounded-2xl border border-[var(--border-hover)] bg-[rgba(12,12,12,0.82)] px-5 py-4 backdrop-blur-xl shadow-[var(--shadow-md)] md:left-7">
            <div className="font-playfair text-2xl text-[var(--accent-gold)]">25+ Years</div>
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--text-secondary)]">of Excellence</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
